<template>
    <div id="referalLoginDiv">
          <HeaderVue />
        <div class="loading">
            <div class="loading-img">
                <img src="static/images/walk.gif" alt="">
            </div>
        </div>
        <header class="reg-header passon-header">
        </header>
        <div class="wrapper pass-on">
            <div class="inner-page reg-content">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-6">
                            <h1 class="red-color">It's time to pass on the goodness</h1>
                            <p>Thank you for being our esteemed customer. You know it’s convenient to get a home blood test
                                done through Labotist. Now your friends and family can benefit too. We have made it easy
                                for you to refer a friend to avail our home blood test services.</p>
                            <p>
                                You get a credit of INR.100 in your Labotist account when your friend books a blood test
                                with us. Of course, we won't leave your friend behind! They get an instant credit of
                                INR.150 as soon as they register with us!
                            </p>
                            <h3>Steps to refer:</h3>
                            <ul>
                                <li>
                                    Login using your Labotist login credentials
                                </li>
                                <li>
                                    You will see the message with referral link
                                </li>
                                <li>
                                    Share the message and link via your preferred mode - facebook, whatsapp, Instagram,
                                    email, etc
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <img src="static/images/logo-svg.svg" class="img-fluid align-center" alt="">
                            <div class="ref-form align-center">
                                <p class="no-mar-top red-color fs-14" v-if="login.error">{{login.errormsg}}</p>
                                <p class="no-mar-top green-color fs-14" v-if="login.successmsg">{{login.successmsg}}</p>
                                <form data-vv-scope="login" v-show="login.otp_send === 1">
                                    <div class="form-group" v-if="!login.login_with_otp">
                                        <input class="form-control" type="text" ref="login_username" name="username" id="username" data-vv-as="email or mobile" v-model="login.username" v-validate="'required'" placeholder="Email or Mobile Number" >
                                        <span v-show="errors.has('login.username')" class="text-danger">{{ errors.first('login.username') }}</span>
                                    </div>
                                    <div class="form-group" v-else>
                                        <input class="form-control" type="text" ref="login_username" v-mask="'##########'" name="username" id="username" data-vv-as="mobile" v-model="login.username" v-validate="'required'" placeholder="Mobile Number" >
                                        <span v-show="errors.has('login.username')" class="text-danger">The mobile number field is required.</span>
                                    </div>
                                    <div class="form-group  mb-2" v-if="!login.login_with_otp">
                                        <input class="form-control" type="password" ref="login_password"  name="password" id="password" data-vv-as="password" v-model="login.password" v-validate="'required'" placeholder="Password" >
                                        <span v-show="errors.has('login.password')" class="text-danger">{{ errors.first('login.password') }}</span>
                                    </div>
                                    <div class="form-group  mb-2" v-else>
                                        <input class="form-control" type="password" placeholder="Password" disabled>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <a data-dismiss="modal" data-toggle="modal" href="#lost" @click="clearFields()" class="mb-3 text-center signup-link float-right display-block" data-target=".forgot" data-backdrop="static" data-keyboard="false">
                                                Forgot Password?
                                            </a>
                                        </div>
                                        <div class="col-sm-12 mb-3">
                                            <label class="checkbox_container">Login With OTP?
                                            <input type="checkbox" ref="login_with_otp"  name="login_with_otp" id="login_with_otp" data-vv-as="login_with_otp" v-model="login.login_with_otp">
                                            <span class="checkbox_checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <button class="btn btn-primary full-width" type="submit" @click.prevent="loginClicked()" >{{!login.login_with_otp ? 'Login' : 'Send OTP'}}</button>
                                </form>
                                <form data-vv-scope="login-wt-otp" v-show="login.otp_send === 2" >
                                    <div class="form-group  mb-2">
                                        <input class="form-control" type="text" ref="login_otp" name="login_otp" id="login_otp" maxlength="6" v-model="login.login_otp" data-vv-as="OTP" v-mask="'##########'" v-validate="'required'" placeholder="Enter your OTP" >
                                        <span v-show="errors.has('login-wt-otp.login_otp')" class="text-danger">{{ errors.first('login-wt-otp.login_otp') }}</span>
                                    </div>
                                    <div class="row">
                                      <div class="col-sm-12">
                                        <a @click="clearFields()" class="mb-3 text-center signup-link blue-color" >
                                            Back to Login?
                                        </a>
                                        <!--<a data-dismiss="modal" data-toggle="modal" href="#lost" @click="clearFields()" class="mb-3 text-center signup-link float-right display-block" data-target=".forgot" data-backdrop="static" data-keyboard="false">
                                            Forgot Password?
                                        </a>-->
                                        <a class="mb-3 text-center signup-link float-right display-block resent_otp" v-on:click="loginWithOtpChanged(true)">Resend OTP?</a>
                                      </div>
                                    </div>
                                    <button class="btn btn-primary full-width mar-b-15" type="submit" @click.prevent="verifyLoginOTP()" >Verify OTP</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="copy-right text-center">
                <p>2017 labotist . All rights received.</p>
            </div> -->
        </div>
        <FooterVue />
    </div>
</template>

<script>
import Vue from 'vue'
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'
// import Sidemenu from '@/components/web/Public/Sidemenu'

export default {
  name: 'ReferalLogin',
  components: {
    HeaderVue,
    // Sidemenu,
    FooterVue
  },
  data () {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType : ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCodeDisable: false
    }
  },
  beforeCreate () {
    if (this.$localStorage.get('loggedIn') && this.$localStorage.get('loggedIn')) {
      console.log(this.$localStorage.get('loggedIn'))
      this.$router.push({ path: '/referral/invite' })
      // this.$router.push({ path: '/' })
    }
  },
  mounted () {
    this.$hidePageLoading()
  },
  methods : {
    loginWithOtpChanged: function (resend) {
      if (this.login.username === '') {
        this.$refs.login_username.focus()
      }
      this.login.error = false
      this.$validator.validateAll('login').then((result) => {
        if (result) {
          if (this.login.username !== '') {
            let data = {
                'mobile': this.login.username
              }
              Promise.resolve(this.$POST('patient/sendOTP', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.login['otp_send'] = 2
                  this.login['error'] = false
                  this.login['errormsg'] = ''
                  if(resend) {
                    this.login['successmsg'] = 'We have resend an OTP to your mobile number.'
                  }else {
                    this.login['successmsg'] = 'We have send an OTP to your mobile number.'
                  }
                  
                  this.login['login_otp'] = ''
                  console.log(this.login)
                } else {
                  this.login['otp_send'] = 1
                  this.login['error'] = true
                  this.login['errormsg'] = res.response_message
                  this.login['successmsg'] = ''
                  this.login['login_otp'] = ''
                }
              }.bind(this)).catch(function (err) {
                console.log('METHOD:forgetPassword', err)
              })
          }
        }
      })
    },
    loginClicked: function () {
      this.login.error = false
      if(this.login.login_with_otp) {
        this.loginWithOtpChanged()
      } else {
        this.logon()
      }
    },
    logon: function () {
      if (this.login.username === '') {
        this.$refs.login_username.focus()
      } else if (this.login.password === '') {
        this.$refs.login_password.focus()
      }
      this.login.error = false
      this.$validator.validateAll('login').then((result) => {
        if (result) {
          if (this.login.username !== '' && this.login.password !== '') {
            this.$logon(this.login.username, this.login.password).then(function (response) {
              if (response.error) {
                this.login.error = true
                this.login.errormsg = response.error
                return false
              } else {
                Vue.analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                })
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide')
                  $('.forgot').modal('show')
                  this.forgot.error = false
                  this.forgot.success = 3
                  return false
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false
                  this.$root.$emit('isLogin', true)
                  $('.login-box').modal('hide')
                  this.$router.push('/address')
                  return false
                } else {
                  this.$root.$emit('isLogin', true)
                  this.$router.push({ path: '/referral/invite' })
                }
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }
      })
    },
    verifyLoginOTP: function () {
      if (this.login.login_otp === '') {
        this.$refs.login_otp.focus()
      }
      this.login.error = false
      this.$validator.validateAll('login-wt-otp').then((result) => {
        if (result) {
          if (this.login.username !== '' && this.login.login_otp !== '') {
            this.$verifyLoginOTP(this.login.username, this.login.login_otp).then(function (response) {
              console.log(response)
              if (response.error) {
                this.login.error = true
                this.login.errormsg = 'Invalid OTP'
                this.login.successmsg = ''
                return false
              } else {
                this.login.error = false
                Vue.analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                })
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide')
                  $('.forgot').modal('show')
                  this.forgot.error = false
                  this.forgot.success = 3
                  return false
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false
                  this.$root.$emit('isLogin', true)
                  $('.login-box').modal('hide')
                  this.$router.push('/address')
                  return false
                } else {
                  this.$root.$emit('isLogin', true)
                  this.$router.push({ path: '/referral/invite' })
                }
                return false
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }
      })
    },
    clearFields: function (type) {
      this.login = {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      this.forgot = {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: ''
      }
      setTimeout(function () {
        this.errors.items = []
      }.bind(this), 200)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/Public/ReferalLogin.vue